import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintenanceManUnBindQrCode
    (deviceId, socketNum) {
    return maintainRequest.post(`/device/maintenanceMan/qrcode/unBindQrCode/${deviceId}/${socketNum}`)
}
